import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { workRegisterKeys } from './workRegisters.key';

type UpdatePersonnelPayload = {
  firstName?: string;
  lastName?: string;
  arrivedAt?: string | null;
};

type Options = {
  onUpdatePersonnelSuccess?: () => void;
  onUpdatePersonnelError?: (error: unknown) => void;
};

export function useUpdatePersonnel(
  personnelId: string,
  controlId: string,
  options?: Options
) {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  const updatePersonnel = async (data: UpdatePersonnelPayload) => {
    const axios = await getAxios();
    const res = await axios.patch(`/api/v1/personnel/${personnelId}`, data);
    return res.data;
  };

  return useMutation(updatePersonnel, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: workRegisterKeys.personnelAll(controlId),
      });
      options?.onUpdatePersonnelSuccess?.();
    },
    onError: (error: unknown) => {
      toast.error('Kunde inte uppdatera personen');
      options?.onUpdatePersonnelError?.(error);
    },
  });
}
